import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getFilesByDate = createAsyncThunk(
  "reports/getFilesByDate",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getFilesByDate(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const AdminLayoutSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setReportsByDate(state, action){
      state.value = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFilesByDate.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFilesByDate.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getFilesByDate.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const reportsByDate = (state) => state.reports ? state.reports.value : "";
export const reportsByDateLoader = (state) => state.reports.loading;
export const {setStatOrdersList} = AdminLayoutSlice.actions;

export default AdminLayoutSlice.reducer;
